import React from 'react';

interface AddImageIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  sx?: any; // For Material-UI sx prop compatibility
}

const AddImageIcon: React.FC<AddImageIconProps> = ({
  width = 41,
  height = 40,
  className = '',
  onClick,
  style,
  sx
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={{ ...style, ...sx }}
    >
      <path
        d="M5.5 34.9998C4.58333 34.9998 3.79861 34.6735 3.14583 34.0207C2.49306 33.3679 2.16667 32.5832 2.16667 31.6665V11.6665C2.16667 10.7498 2.49306 9.96512 3.14583 9.31234C3.79861 8.65956 4.58333 8.33317 5.5 8.33317H10.75L13.8333 4.99984H23.8333V8.33317H15.2917L12.25 11.6665H5.5V31.6665H32.1667V16.6665H35.5V31.6665C35.5 32.5832 35.1736 33.3679 34.5208 34.0207C33.8681 34.6735 33.0833 34.9998 32.1667 34.9998H5.5ZM32.1667 11.6665V8.33317H28.8333V4.99984H32.1667V1.6665H35.5V4.99984H38.8333V8.33317H35.5V11.6665H32.1667ZM18.8333 29.1665C20.9167 29.1665 22.6875 28.4373 24.1458 26.979C25.6042 25.5207 26.3333 23.7498 26.3333 21.6665C26.3333 19.5832 25.6042 17.8123 24.1458 16.354C22.6875 14.8957 20.9167 14.1665 18.8333 14.1665C16.75 14.1665 14.9792 14.8957 13.5208 16.354C12.0625 17.8123 11.3333 19.5832 11.3333 21.6665C11.3333 23.7498 12.0625 25.5207 13.5208 26.979C14.9792 28.4373 16.75 29.1665 18.8333 29.1665ZM18.8333 25.8332C17.6667 25.8332 16.6806 25.4304 15.875 24.6248C15.0694 23.8193 14.6667 22.8332 14.6667 21.6665C14.6667 20.4998 15.0694 19.5137 15.875 18.7082C16.6806 17.9026 17.6667 17.4998 18.8333 17.4998C20 17.4998 20.9861 17.9026 21.7917 18.7082C22.5972 19.5137 23 20.4998 23 21.6665C23 22.8332 22.5972 23.8193 21.7917 24.6248C20.9861 25.4304 20 25.8332 18.8333 25.8332Z"
        fill="#7F7F7F"
        fillOpacity="0.5"
        style={{ mixBlendMode: 'luminosity' }}
      />
      <path
        d="M5.5 34.9998C4.58333 34.9998 3.79861 34.6735 3.14583 34.0207C2.49306 33.3679 2.16667 32.5832 2.16667 31.6665V11.6665C2.16667 10.7498 2.49306 9.96512 3.14583 9.31234C3.79861 8.65956 4.58333 8.33317 5.5 8.33317H10.75L13.8333 4.99984H23.8333V8.33317H15.2917L12.25 11.6665H5.5V31.6665H32.1667V16.6665H35.5V31.6665C35.5 32.5832 35.1736 33.3679 34.5208 34.0207C33.8681 34.6735 33.0833 34.9998 32.1667 34.9998H5.5ZM32.1667 11.6665V8.33317H28.8333V4.99984H32.1667V1.6665H35.5V4.99984H38.8333V8.33317H35.5V11.6665H32.1667ZM18.8333 29.1665C20.9167 29.1665 22.6875 28.4373 24.1458 26.979C25.6042 25.5207 26.3333 23.7498 26.3333 21.6665C26.3333 19.5832 25.6042 17.8123 24.1458 16.354C22.6875 14.8957 20.9167 14.1665 18.8333 14.1665C16.75 14.1665 14.9792 14.8957 13.5208 16.354C12.0625 17.8123 11.3333 19.5832 11.3333 21.6665C11.3333 23.7498 12.0625 25.5207 13.5208 26.979C14.9792 28.4373 16.75 29.1665 18.8333 29.1665ZM18.8333 25.8332C17.6667 25.8332 16.6806 25.4304 15.875 24.6248C15.0694 23.8193 14.6667 22.8332 14.6667 21.6665C14.6667 20.4998 15.0694 19.5137 15.875 18.7082C16.6806 17.9026 17.6667 17.4998 18.8333 17.4998C20 17.4998 20.9861 17.9026 21.7917 18.7082C22.5972 19.5137 23 20.4998 23 21.6665C23 22.8332 22.5972 23.8193 21.7917 24.6248C20.9861 25.4304 20 25.8332 18.8333 25.8332Z"
        fill="#3D3D3D"
        style={{ mixBlendMode: 'overlay' }}
      />
    </svg>
  );
};

export default AddImageIcon;
